// export const PUBLIC_VAPID_KEY = 'BGRzWd2JivvoXNLUQ6yb1iRuOxIse9K8L4h2jtlWaVzilmIw0Y1PiJ_GLjwtmWiCV-mf_ek_4xopLLlz5hGCW84'
export const PUBLIC_VAPID_KEY =
  'BOYp8OYAJj0cEvV0e0jna_0RpvD7zRP1zlzQUHuniCOakEqBLj8V8PacEpaHJYLTUveJwbXb1ellHvE7_TrXF_o'



// WEBPACK FOOTER //
// ./src/constants/firebase.js